/*
 * Get the location breadcrumbs on contact page and put them in the nav for mobile
 */
(function($){
	var location_links = $('.sidebar_contact ul').clone(true);
	location_links.addClass('location_links sidebar_contact');
	//for subpage of contact page
	if($('.nav .current-menu-item a.active').length > 0){
		var parent = $('.nav .current-menu-item a.active');
		location_links.insertAfter(parent);
	}
	//for parent contact page
	else{
		location_links.prependTo('.nav .current-menu-item .child-menu');
	}

})(jQuery);